import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ProjectSummaryReportCellType, ProjectSummaryReportGraphLink, ProjectSummaryReportLink, ProjectSummaryReportPatternLink, ProjectSummaryReportPatternValue, ProjectSummaryReportPatternValues } from '../project-summary-report.model';
import { NavigationService } from '../../../../navbar/navigation.service';

@Component({
    selector: 'adm4-project-summary-report-table-cell',
    template: `
@switch (cell.type) {
  @case (patternLink) {
    <div>
      @if (cell.linkName && cell.linkId) {
        <a (click)='navigateToPattern(cell.linkId)' [innerHTML]='cell.linkName | highlight : textToHighlight'></a>
      }
    </div>
    <div class='link-description' [innerHTML]='cell.linkDescription | highlight : textToHighlight'></div>
  }
  @case (link) {
    @if (cell.linkName && cell.link) {
      <a (click)='navigateToServices(cell.link)' [innerHTML]='cell.linkName | highlight : textToHighlight'></a>
      }<br/>
    }
    @case (graphLink) {
      <adm4-link [linkURL]='getGraphViewLink(cell.patternId)' target='_blank'>
        <div class='icon-with-link-text-wrapper'>
          <div [innerHTML]='cell.linkName | highlight : textToHighlight'></div>
          <mat-icon class='new-tab-icon'>open_in_new</mat-icon>
        </div>
      </adm4-link>
    }
    @case (values) {
      @for (value of cell.values; track value) {
        <div class='value' [innerHTML]='value | highlight : textToHighlight'></div>
      }
    }
    @case (value) {
      <div class='value' [innerHTML]='cell.value | highlight : textToHighlight'></div>
    }
  }
`,
    styleUrls: ['./project-summary-report-table-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProjectSummaryReportTableCellComponent {
  private navigationService = inject(NavigationService);


  @Input() cell: ProjectSummaryReportPatternLink | ProjectSummaryReportGraphLink | ProjectSummaryReportLink | ProjectSummaryReportPatternValues | ProjectSummaryReportPatternValue;
  @Input() projectKey: string;
  @Input() textToHighlight: string;

  readonly patternLink = ProjectSummaryReportCellType.patternLink;
  readonly graphLink = ProjectSummaryReportCellType.graphLink;
  readonly link = ProjectSummaryReportCellType.link;
  readonly values = ProjectSummaryReportCellType.values;
  readonly value = ProjectSummaryReportCellType.value;

  navigateToPattern(patternId: string): void {
    this.navigationService.navigateToPattern(this.projectKey, patternId);
  }

  navigateToServices(realmName: string) {
    this.navigationService.navigateToSummaryTabWithSearch(this.projectKey, 'applications', realmName);
  }

  getGraphViewLink(patternId: string): string {
    return this.navigationService.getGraphViewLink(this.projectKey, patternId);
  }
}
